import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logged: false,
    user: null,
    menu: false,
    popup: false,
    journey: null,
    whitePopup: null,
    tutorial: null,
    error: null,
    journeyDialog: null,
    save: false,
    option: null,
    sequence: false,
    reset: false,
    reset2: false,
    scroll: false,
    mobileRouter: '/',
    logoff: false,
    resetQuiz: []
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
      if (payload) {
        axios.defaults.headers.common['X-Access-Token'] = state.user.token
        state.logged = true
      } else {
        delete axios.defaults.headers.common['X-Access-Token']
        state.logged = false
      }
    },
    setMenu (state, payload) {
      state.menu = payload
    },
    setPopup (state, payload) {
      state.popup = payload
      state.sequence = true
    },
    setJourney (state, payload) {
      state.journey = payload
    },
    setJourneyDialog (state, payload) {
      state.journeyDialog = payload
    },
    setWhitePopUp (state, payload) {
      state.whitePopup = payload
    },
    setTutorial (state, payload) {
      state.tutorial = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setSave (state, payload) {
      state.save = payload
    },
    setOption (state, payload) {
      state.option = payload
    },
    setSequence (state, payload) {
      state.sequence = payload
    },
    setReset (state, payload) {
      state.reset = payload
    },
    setReset2 (state, payload) {
      state.reset2 = payload
    },
    setScroll (state, payload) {
      state.scroll = payload
    },
    setMobileRouter (state, payload) {
      state.mobileRouter = payload
    },
    setLogoff (state, payload) {
      state.logoff = payload
    },
    setResetQuiz (state, payload) {
      state.resetQuiz = payload
    }
  },
  actions: {
    setUserInfo (context, payload) {
      this.commit('setUser', payload.user)
    },
    setMenuInfo (context, payload) {
      this.commit('setMenu', payload)
    },
    setPopupInfo (context, payload) {
      this.commit('setPopup', payload)
    },
    setJourneyInfo (context, payload) {
      this.commit('setJourney', payload)
    },
    setJourneyDialogInfo (context, payload) {
      this.commit('setJourneyDialog', payload)
    },
    setWhitePopUpInfo (context, payload) {
      this.commit('setWhitePopUp', payload)
    },
    setTutorialInfo (context, payload) {
      this.commit('setTutorial', payload)
    },
    setErrorInfo (context, payload) {
      this.commit('setError', payload)
    },
    setSaveInfo (context, payload) {
      this.commit('setSave', payload)
    },
    setOptionInfo (context, payload) {
      this.commit('setOption', payload)
    },
    setSequenceInfo (context, payload) {
      this.commit('setSequence', payload)
    },
    setResetInfo (context, payload) {
      this.commit('setReset', payload)
    },
    setReset2Info (context, payload) {
      this.commit('setReset2', payload)
    },
    setScrollInfo (context, payload) {
      this.commit('setScroll', payload)
    },
    setMobileRouterInfo (context, payload) {
      this.commit('setMobileRouter', payload)
    },
    setLogoffInfo (context, payload) {
      this.commit('setLogoff', payload)
    },
    setResetQuizInfo (context, payload) {
      this.commit('setResetQuiz', payload)
    }
  }
})
